module.exports = __webpack_public_path__ + "img/HTCC-CPC01.83681013.jpg";